import { FC } from "react";

import BasicEditor from "../BasicEditor";
import { mentionVariables } from "../BasicEditor/extensions";
import { langs } from "@uiw/codemirror-extensions-langs";

export interface PythonEditorProps {
  value?: string;
  onChange: (v: string) => void;
  variables: { label: string; key: string }[];
}

// Python 编辑器
const PythonEditor: FC<PythonEditorProps> = ({
  onChange,
  variables,
  value,
}) => {
  return (
    <BasicEditor
      value={value}
      onChange={onChange}
      language="python"
      extensions={[
        mentionVariables(
          variables.map((v) => ({
            label: `${v.key}`,
            displayLabel: v.label,
            type: "variable",
          }))
        ),
        langs.python(),
      ]}
    />
  );
};

export default PythonEditor;
